import { styled } from '@mui/material';

export const ProgressWithLabelWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
}));

export const ProgressWithLabelProgressWrap = styled('div')(({ theme }) => ({
	marginRight: '8px',
	width: '100%',

	[theme.breakpoints.down('sm')]: {
		marginRight: '16px',
	},
}));
